import type { IconLoaders } from "../types";

/** Verbs on buttons and menus */
export const actionIcons = {
    arrow_path: () => import("./arrow_path"),
    arrows_pointing_in: () => import("./arrows_pointing_in"),
    arrows_pointing_out: () => import("./arrows_pointing_out"),
    circle_plus: () => import("./circle_plus"),
    close: () => import("./close"),
    close_bold: () => import("./close_bold"),
    close_small: () => import("./close_small"),
    columns: () => import("./columns"),
    copy: () => import("./copy"),
    delete: () => import("./delete"),
    dots_horizontal: () => import("./dots_horizontal"),
    edit_pen: () => import("./edit_pen"),
    ellipsis_vertical: () => import("./ellipsis_vertical"),
    eye: () => import("./eye"),
    eyeStrikethrough: () => import("./eye-strikethrough"),
    filter: () => import("./filter"),
    link: () => import("./link"),
    magnifying_glass: () => import("./magnifying_glass"),
    plus: () => import("./plus"),
    plus_circle: () => import("./plus_circle"),
    plus_outline: () => import("./plus_outline"),
    refresh: () => import("./refresh"),
    revert: () => import("./revert"),
    save: () => import("./save"),
    search: () => import("./search"),
    trash: () => import("./trash"),
    x_mark: () => import("./x_mark"),
} satisfies IconLoaders;
